import { FC } from 'react';
import { Discovery } from 'components/Discovery';

const InformationView: FC = () => {

    return (
        <Discovery containerName={'Information'} />
    );
}

export default InformationView;
